import React from 'react'
import { observer } from "mobx-react-lite"
import GraphicEqIcon from '@mui/icons-material/GraphicEq';

import classes from './CreditIcon.module.scss'


const CreditIcon = observer(({size}) => {
  const innerSize = size * 0.725;
  return <div className={classes.iconWrap} style={{width: size, height: size}}>
    <div className={classes.iconBorder} style={{width: innerSize, height: innerSize}}>
      <GraphicEqIcon className={classes.iconImg} />
    </div>
  </div>
})

export default CreditIcon;